import { ConfigurationDto, DatasetId } from "@intelligems/ig-types";
import { GraphConfig } from "@src/features/analytics/types";
import { IExperienceDashboardFilters } from "@src/store/types/dashboardFilters";
import { ISitewideDashboardFilters } from "@src/store/types/sitewideDashboardFilters";

export function getMaxZScore(
  maxZScoreFilter: string | number | null | undefined,
  isZScoreEnabled: boolean,
  maxZScore: ConfigurationDto | undefined
): string | number {
  if (!isZScoreEnabled) {
    return "9999";
  }
  const defaultMaxZScore = maxZScore?.value;
  return Math.min(maxZScoreFilter ?? defaultMaxZScore, defaultMaxZScore);
}

export const getTinybirdActiveAnalyticsFilters = (
  filters: IExperienceDashboardFilters | ISitewideDashboardFilters,
  defaultMaxZScore: number
): Partial<IExperienceDashboardFilters> => {
  const result: Partial<IExperienceDashboardFilters> = {};

  if (filters.deviceType !== "any" && filters.deviceType !== null) {
    result.deviceType = filters.deviceType;
  }
  if (filters.visitorType !== "any" && filters.visitorType !== null) {
    result.visitorType = filters.visitorType;
  }
  if (filters.channels.length) {
    result.channels = filters.channels;
  }

  if (filters.countryCodes.length) {
    result.countryCodes = filters.countryCodes;
  }

  if ("testOrdersOnly" in filters && filters.testOrdersOnly === true) {
    result.testOrdersOnly = filters.testOrdersOnly;
  }
  if ("customEvents" in filters && filters.customEvents.length) {
    result.customEvents = filters.customEvents;
  }
  if (
    "reachedCheckoutStage" in filters &&
    filters.reachedCheckoutStage !== "any" &&
    filters.reachedCheckoutStage !== null
  ) {
    result.reachedCheckoutStage = filters.reachedCheckoutStage;
  }

  if ("urlParam" in filters && filters.urlParam.queryParam !== null) {
    result.urlParam = filters.urlParam;
  }
  if (filters?.landingPage?.landingPageUrlPath != null) {
    result.landingPage = filters.landingPage;
  }
  if (defaultMaxZScore !== filters.maxZScore) {
    result.maxZScore = filters.maxZScore;
  }

  if (filters.endTime) {
    result.endTime = filters.endTime;
  }
  if (filters.startTime) {
    result.startTime = filters.startTime;
  }

  return result;
};

export const transformMetricsConfig = (
  graphConfigs: GraphConfig[]
): { datasetId: DatasetId; metrics: string[] }[] => {
  const datasetMetricsMap = new Map<DatasetId, Set<string>>();

  const addMetricsToMap = (config: GraphConfig) => {
    const existing =
      datasetMetricsMap.get(config.datasetId) || new Set<DatasetId>();
    config.metrics.forEach((metric) => existing.add(metric));
    datasetMetricsMap.set(config.datasetId, existing);
  };

  graphConfigs.forEach((config: GraphConfig) => {
    addMetricsToMap(config);
  });

  // Convert map to desired output format
  return Array.from(datasetMetricsMap.entries()).map(
    ([datasetId, metricsSet]) => ({
      datasetId,
      metrics: Array.from(metricsSet),
    })
  );
};
